import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Virksomhed',
      links: [
        { name: 'Om MUSEIQ', path: '/about' },
        { name: 'Festivaler', path: '/festivals' },
        { name: 'Festivalkalender', path: '/festival-kalender' },
        { name: 'Partnere', path: '/partners' },
        { name: 'Support', path: '/support' },
      ],
    },
  ];

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="md:col-span-3">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="/museiq-logo.png" 
                alt="MUSEIQ" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-primary-foreground/80 mb-6 max-w-md">
              Event operations platform der samler betaling, drift og data for festivaler og live events.
            </p>
            <div className="space-y-3 text-sm text-primary-foreground/70">
              <div className="flex items-center space-x-3">
                <Mail size={16} />
                <a
                  href="mailto:info@museiq.io"
                  className="hover:text-primary-foreground transition-colors"
                >
                  info@museiq.io
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={16} />
                <a
                  href="tel:+4529847622"
                  className="hover:text-primary-foreground transition-colors"
                >
                  +45 29 84 76 22
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={16} />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Errits%C3%B8%20Bygade%2092%2C%207000%20Fredericia"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-primary-foreground transition-colors"
                >
                  Erritsø Bygade 92, 7000 Fredericia
                </a>
              </div>
            </div>
            <div className="mt-6 flex items-center gap-4">
              <a
                href="https://www.instagram.com/wearemuseiq/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                <Instagram size={38} />
              </a>
              <a
                href="https://dk.linkedin.com/company/museiq"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                <Linkedin size={38} />
              </a>
            </div>
            <p className="mt-5 text-sm text-primary-foreground/70">
              CVR 43572261
            </p>
          </div>

          {/* Links Sections */}
          {footerLinks.map((section) => (
            <div key={section.title} className="md:justify-self-end md:pt-10">
              <h3 className="font-heading font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-primary-foreground/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-primary-foreground/60">
              © {currentYear} MUSEIQ. Alle rettigheder forbeholdes.
            </p>
            <div className="flex items-center gap-6 text-sm text-primary-foreground/60">
              <Link to="/support" className="hover:text-primary-foreground transition-colors">
                Support
              </Link>
              <Link to="/privacy-policy" className="hover:text-primary-foreground transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
